import Vue from 'vue'
import VueI18n from 'vue-i18n'

VueI18n.prototype.de = function (key, locale) {
  return !!this._te(key, this.locale, this.dateTimeFormats, locale)
}
VueI18n.prototype.ne = function (key, locale) {
  return !!this._te(key, this.locale, this.numberFormats, locale)
}
VueI18n.prototype._date = VueI18n.prototype.d
/**
 * 
 * @param {number|Date} value 
 * @param {VueI18n.Path} key 
 * @param {{ date: string, time: string, datetime: string }} separators 
 * @param {VueI18n.Locale} locale 
 * @returns 
 */
VueI18n.prototype.d = function (value, key, separators = {}, locale) {
  if (!locale) {
    locale = this.locale
  }
  if (typeof value === 'string') {
    const date = new Date(value)
    if (isNaN(new Date(value).getTime())) {
      return value
    }
    value = date
  }
  var strDate = this._date(value, key, locale)
  if (separators.date !== null && separators.date !== undefined) {
    strDate = strDate.replace(/[\\/\\.]/g, separators.date)
  }
  if (separators.time !== null && separators.time !== undefined) {
    strDate = strDate.replace(/:/g, separators.time)
  }
  if (separators.datetime !== null && separators.datetime !== undefined) {
    strDate = strDate.replace(/, /g, separators.datetime)
  }
  return strDate
}
VueI18n.prototype._number = VueI18n.prototype.n
VueI18n.prototype.n = function (value, key, locale) {
  if (!locale) {
    locale = this.locale
  }
  if (key === 'integer' || key === 'integer_group') {
    value = Math.trunc(Number(value))
  }
  if (key === 'percent' || key === 'percent_decimal') {
    value = Number(value) / 100
  }
  return this._number(value, key, locale)
}

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function loadLocaleFormats () {
  const formats = require.context('./locales-formats', true, /[A-Za-z0-9-_,\s]+\/[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  formats.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_,\s]+)\/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 2) {
      const typeFormat = `${matched[1]}Formats`
      const locale = matched[2]
      if (!messages[typeFormat]) {
        messages[typeFormat] = {}
      }
      messages[typeFormat][locale] = formats(key)
    } else if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = formats(key)
    }
  })
  return messages
}

function getClosestLocale (requestedLocale, localeOptions = { count: 0, availableLocales: i18n.availableLocales }) {
  if (!Object.hasOwnProperty.call(localeOptions, 'count') || typeof localeOptions.count !== 'number' || localeOptions.count < 0) {
    localeOptions.count = 0
  }
  if (!Object.hasOwnProperty.call(localeOptions, 'availableLocales') || !Array.isArray(localeOptions.availableLocales) || localeOptions.availableLocales.length <= 0) {
    localeOptions.availableLocales = i18n.availableLocales
  }

  if (localeOptions.availableLocales.includes(requestedLocale)) {
    if (requestedLocale === 'en') return 'en-GB'
    return requestedLocale
  }

  if (requestedLocale.includes('-')) {
    const baseLocale = requestedLocale.split('-')[0]
    localeOptions.count++
    return getClosestLocale(baseLocale, localeOptions)
  }

  const specificLocale = localeOptions.availableLocales.find(locale => locale.startsWith(`${requestedLocale}-`))
  if (specificLocale) {
    localeOptions.count++
    return specificLocale
  }

  localeOptions.count = 9999
  return i18n.fallbackLocale
}


function getLocale () {
  const locale = window.navigator.languages || window.navigator.language || window.navigator.userLanguage || i18n.locale
  // const locale = 'en'
  // const locale = 'fr'
  // const locale = 'de'
  // const locale = 'ca'

  const locales = Array.isArray(locale) ? locale : [locale]

  let bestLocale = null
  let bestChangeCount = Infinity

  for (const requestedLocale of locales) {
    const localeOptions = { count: 0 }
    const matchedLocale = getClosestLocale(requestedLocale, localeOptions)

    if (localeOptions.count !== 9999) {
      return matchedLocale
    }

    if (localeOptions.count < bestChangeCount) {
      bestLocale = matchedLocale
      bestChangeCount = localeOptions.count
    }
  }

  if (!bestLocale || bestChangeCount === 9999) {
    // console.warn(`Warning: Locale '${locales}' not found. Using default '${process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'es'}'`)
  }
  return bestLocale || i18n.fallbackLocale
}

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'es',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'es',
  messages: loadLocaleMessages(),
  ...loadLocaleFormats(),
  silentTranslationWarn: true
})
i18n.locale = getLocale()

export { i18n, getLocale, getClosestLocale }
